import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { WorkspaceItem, SelectedSort, ItemPosition } from 'Shared/constants/types';
import WpIcon from 'Wpds/components/icon/WpIcon';
import WpButton from 'Wpds/components/button/WpButton';
import ActionItemsWithNestingTable from 'Shared/components/ActionItems/ActionItemsWithNestingTable/ActionItemsWithNestingTable';
import { createItemFromSourceItemAction } from 'Shared/actions/meetingItems';

import './ThreeSixtySharePageActionItemsList.scss';

type Props = {
  reviewSlug: string;
  selectedSort: SelectedSort;
  actionItems: Array<WorkspaceItem>;
  onAddItemClick(): void;
  setSelectedSort: Function;
};

function ThreeSixtySharePageActionItemsList({
  reviewSlug,
  actionItems,
  onAddItemClick,
  selectedSort,
  setSelectedSort,
}: Props) {
  const dispatch = useDispatch();

  const handleCreateOnEnter = useCallback(
    ({ sourceItemUuid, itemUuid }) => {
      dispatch(
        createItemFromSourceItemAction({
          sourceItemUuid,
          itemUuid,
          positionField: ItemPosition.positionForHomePage,
        })
      );
    },
    [dispatch, reviewSlug]
  );

  return (
    <div className="ThreeSixtySharePagePageActionItemsList">
      <ActionItemsWithNestingTable
        withOwnerSection
        withWorkspaceSection={false}
        positionField={ItemPosition.positionForHomePage}
        actionItems={actionItems}
        selectedSort={selectedSort}
        onCreateItem={handleCreateOnEnter}
        setSelectedSort={setSelectedSort}
        forbidDrag
      />
      <div className="ThreeSixtySharePageActionItemsList__add d-flex py-2 pl-3">
        <WpButton variant="tertiary" onClick={onAddItemClick}>
          <WpIcon name="plus-circle" />
          Add Action Item
        </WpButton>
      </div>
    </div>
  );
}

export default ThreeSixtySharePageActionItemsList;
